import React from 'react';

type Props = {
  assesments?: string[];
};

export const Assessment: React.FC<Props> = ({ assesments }): JSX.Element => {
  const attrs = {
    wrapper: { className: 'assessment' },
    header: { className: 'assessment__header' },
    body: {
      wrapper: { className: 'assessment__body' },
      message: { className: 'assessment__body-message' },
    },
  };

  const assesmentInsights = assesments?.length
    ? assesments.map((el: string) => (
        <div key={el} {...attrs.body.message}>
          {el}
        </div>
      ))
    : '';

  return (
    <div {...attrs.wrapper}>
      <div {...attrs.header}>Summary</div>
      <div {...attrs.body.wrapper}>{assesmentInsights}</div>
    </div>
  );
};
